module.exports = __webpack_public_path__ + "img/bmp.cd1e2e7b.svg";